import BaseFreePersonalityTest from 'ui/pages/free-personality-test'
import profileService from 'utils/services/profileService';

const FreePersonalityTest = () => (
  <BaseFreePersonalityTest submit={profileService.getTestResults} />
);

FreePersonalityTest.prettyName = 'Free Personality Test';

export default FreePersonalityTest;
